import { render, staticRenderFns } from "./position_target.vue?vue&type=template&id=0eb08d58&"
import script from "./position_target.vue?vue&type=script&lang=js&"
export * from "./position_target.vue?vue&type=script&lang=js&"
import style0 from "./position_target.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports